const Constants = {
    baseUrl: 'https://workshop-mongoexpress.herokuapp.com'
}
export default Constants
